module.exports = __webpack_public_path__ + "img/2002-Carinthia-Druckzentrum.b2fd761a.jpg";